import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
// import TickIcon from "Assets/Icons/TickIcon";
// import TickIconMB from "Assets/Icons/TickIconMB";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import { Spinner } from "reactstrap";
import styled from "styled-components";
//import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import StarRating from "./StarRating";

const DivView = styled<any>("div")`
  padding: 0px 0px 0px 16px;
  overflow: auto;
`;
const DivViewSub = styled<any>("div")`
  padding: 8px 0px 8px 0px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
const Div1 = styled<any>("div")`
  color: #333333;
  font-size: 16px;
  width: 60%;
  color: var(--Grey-80, #333);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
`;
const Div2 = styled<any>("div")`
  color: #333333;
  font-size: 16px;
  width: 40%;
`;
export interface FeedbackViewListingIF {
  data: any;
  Loader: boolean;
}
const FeedbackViewListing = ({ data, Loader }: FeedbackViewListingIF) => {
  //const { screen }: any = useWindowSize();
  const renderName = (item: any) => {
    switch (item) {
      case "behaviourInClassResponseAvg":
        return "Class Behaviour";
      case "teachingPaceResponseAvg":
        return "Teaching Pace";
      case "doubtResolutionResponseAvg":
        return "Doubt Resolution";
      default:
        return null;
    }
  };
  return (
    <>
      {data && data.length == 0 ? (
        <div className="mt-4 mb-8">
          <NoResultFoundSearch
            primaryMessage="Feedback data not available"
            secondaryMessage={""}
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      ) : (
        <>
          {Loader ? (
            <div>
              <Spinner color="info"></Spinner>
            </div>
          ) : (
            <DivView>
              {data.map((item: any) => {
                return (
                  item.type !== "overallRatingResponseAvg" &&
                  renderName(item.type) !== null && (
                    <DivViewSub key={renderName(item.type)}>
                      <Div1>{renderName(item.type)}</Div1>
                      <Div2>{<StarRating rating={item.value} />} </Div2>
                    </DivViewSub>
                  )
                );
              })}
            </DivView>
          )}
        </>
      )}
    </>
  );
};
export default FeedbackViewListing;
